import React from 'react';
import { observer } from "mobx-react";
import styled, { AnyStyledComponent } from 'styled-components';
import { BalanceType } from '../../../common/const/wallet_balance_type';
import { OrbitComponent } from "../base-components/orbit-component/orbit-component";

interface IBalanceValueProps {
    balanceType?: BalanceType;
    className?: string;
    WrapperComponent?: AnyStyledComponent;
}

export const BalanceValue = observer(class BalanceValue extends OrbitComponent<IBalanceValueProps> {
    static defaultProps: Partial<IBalanceValueProps> = {
        balanceType: BalanceType.BOTH,
        WrapperComponent: styled.span`
            color: ${props => props.theme.colors.moneyColor};
        `
    };
    render() {
        let bankroll = this.services.walletProxy.bankroll[this.props.balanceType!];
        const balanceMaxChars = 15;
        // Bankroll length limited by 15 chars
        const numberIndex = bankroll.search(/[0-9]/g);
        const symbolIndex = bankroll.search(/[^0-9.,]/g);
        let balance: string;

        if (numberIndex > symbolIndex) {
            balance = bankroll.slice(numberIndex, numberIndex + balanceMaxChars);
            bankroll = bankroll.slice(symbolIndex, numberIndex) + balance;
        } else {
            balance = bankroll.slice(numberIndex, Math.min(balanceMaxChars, symbolIndex - numberIndex));
            bankroll = balance + bankroll.slice(symbolIndex);
        }

        let WrapperComponent = this.props.WrapperComponent!;
        return <WrapperComponent className={this.props.className}>
            { bankroll }
        </WrapperComponent>;
    }
});
